import { CellClickedEvent } from 'ag-grid-community';
import { ClaimRow } from 'api/endpoints';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildSingleClaimPath } from 'utils/hooks/useClaimToolQueryParams';
import { REFERENCE_NUMBER_COLUMN } from '../../const';
import { SectionType, SubsectionType } from '../../types';

function useRefClick(section: SectionType, subsection: SubsectionType) {
  const navigate = useNavigate();

  const onRefCellClickedInjector = useCallback(
    (event: CellClickedEvent<ClaimRow>) => {
      const { column, data } = event;
      if (column.getColDef().field !== REFERENCE_NUMBER_COLUMN) return;
      const claimId = data?.id;
      if (!claimId) return;
      navigate(buildSingleClaimPath(data?.id, section, subsection));
    },
    [navigate, section, subsection],
  );
  return {
    onRefCellClickedInjector,
  };
}

export default useRefClick;
